import { defineStyle as e, defineStyleConfig as i } from "@chakra-ui/styled-system";
const t = e({
  fontFamily: "heading",
  fontWeight: "bold",
  letterSpacing: "normal"
}), n = {
  "4xl": e({
    fontSize: "2.5rem",
    lineHeight: "14"
  }),
  "3xl": e({
    fontSize: "2rem",
    lineHeight: "11"
  }),
  "2xl": e({
    fontSize: "1.75rem",
    lineHeight: "9"
  }),
  xl: e({
    fontSize: "2xl",
    lineHeight: "8"
  }),
  lg: e({
    fontSize: "xl",
    lineHeight: "7"
  }),
  md: e({
    fontSize: "lg",
    lineHeight: "6"
  }),
  sm: e({
    fontSize: "md",
    lineHeight: "6"
  }),
  xs: e({
    fontSize: "sm",
    lineHeight: "6"
  })
}, o = i({
  baseStyle: t,
  sizes: n,
  defaultProps: {
    size: "3xl"
  }
});
export {
  o as headingTheme
};
